import { Button } from 'antd';

import { useDownloadCSV, useUserRole } from 'hooks';

export const DownloadCSVButton = ({ url }: { url: string }) => {
  const { isAdmin } = useUserRole();

  const [handleDownloadCSV, { loading }] = useDownloadCSV(url);

  if (!isAdmin) {
    return null;
  }

  return (
    <Button
      type='primary'
      loading={loading}
      onClick={handleDownloadCSV}
    >
      Download CSV
    </Button>
  );
};
